import { createSelector } from 'reselect';

const getUploadState = state => state.fileUpload;

export const getFileUpload = createSelector([getUploadState], fileUpload => fileUpload);
